<template>
  <div class="jflow-restitution-box">
    <Row style="margin-top:10px">
      <Col span="24">
      <div>
        <span style="">回转批注：</span>
        <Input class="ref_input" v-model="inputValue" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入转发批注" />
      </div>
      </Col>
    </Row>
    <div class="pop-btn">
      <Button class="cancel-btn" @click="cancel">
        <span>{{ chineseName.CANCEL }}</span>
      </Button>
      <Button type="error" class="sav-btn" @click="save">
        <span>{{ chineseName.CONFIRM }}</span>
      </Button>
    </div>
  </div>
</template>

<script>
import ChineseDictionary from "@/assets/js/ChineseDictionary";
export default {
  name: "JflowRestitution",
  inject: ["moduleComponentName", "instanceRouteQuery", "instanceRoute"],
  data() {
    return {
      inputValue: ""
    };
  },
  created() {
    this.chineseName = ChineseDictionary;
    console.log('userInfo :>> ', this.$store.state.global.userInfo);
  },
  activated() { },
  destroyed() { },
  methods: {
    save() {
      if (!this.inputValue.trim()) {
        const data = {
          mask: true,
          title: "警告",
          content: "请输入回转批注",
        };
        this.$Modal.fcWarning(data);
        return;
      }
      const { tableName, tableId, itemId } = this.$router.currentRoute.params;
      const params = {
        table: tableName,
        tableId: tableId,
        objid: itemId,
        approver: this.$store.state.global.userInfo.id,
        approverName: this.$store.state.global.userInfo.ename,
        transpondComment: this.inputValue,
      };
      // console.log('params :>> ', params);
      this.$network.post("/p/cs/jflowRestitution", params).then((res) => {
        if (res.data.data.code == 0) {
          this.$Modal.fcSuccess({
            title: "成功",
            content: "回转成功",
          });
          this.$emit("closeActionDialog", true); // 关闭弹框

        } else {
          this.$Modal.fcError({
            title: "失败",
            content: res.data.data.message,
          });
          this.$emit("closeActionDialog", true); // 关闭弹框
        }
      });
    }, // 确定
    cancel() {
      this.$emit("closeActionDialog", false); // 关闭弹框
    }, // 取消
  },
};
</script>

<style lang="less">
.jflow-restitution-box {
  .ref_input {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .pop-btn {
    display: flex;
    flex-direction: row-reverse;

    .cancel-btn {
      margin-left: 10px;
    }
  }
}
</style>
